import React from 'react';
import { Lead } from '../../types/Lead';
import { MemberManager } from '../members/MemberManager';
import { LinkedInButton } from '../ui/LinkedInButton';
import ExpandableMetricCard from '../ui/ExpandableMetricCard';

interface LeadCardContentProps {
  lead: Lead;
  onMembersUpdate?: () => void;
  memberRefreshTrigger?: number;
}

const LeadCardContent: React.FC<LeadCardContentProps> = ({ lead, onMembersUpdate, memberRefreshTrigger }) => {
  return (
    <div style={{
      padding: '0 24px 24px',
      borderTop: '1px solid #e5e7eb',
      backgroundColor: 'rgba(255, 255, 255, 0.5)'
    }}>
      <div style={{ paddingTop: '24px' }}>
        {/* Member Management */}
        {lead.id && (
          <div style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '16px',
            marginBottom: '24px',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
          }}>
            <MemberManager
              leadId={lead.id}
              compact={false}
              onMembersUpdate={onMembersUpdate}
              memberRefreshTrigger={memberRefreshTrigger}
            />
          </div>
        )}

        {/* Overall Assessment */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '16px',
          marginBottom: '24px',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
        }}>
          <h4 style={{ fontWeight: '600', marginBottom: '8px' }}>Overall Assessment</h4>
          <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px' }}>
            {lead.overallScore.description}
          </p>
          <p style={{ fontSize: '14px', color: '#374151', fontWeight: '500' }}>
            {lead.overallScore.reason}
          </p>
        </div>

        {/* Detailed Metrics */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '16px',
          marginBottom: '24px',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
        }}>
          <h4 style={{ fontWeight: '600', marginBottom: '16px' }}>Detailed Metrics</h4>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '16px' }}>
            {Object.entries(lead.metrics).map(([key, metric]) => (
              <ExpandableMetricCard
                key={key}
                metricKey={key}
                metric={metric}
              />
            ))}
          </div>
        </div>

        {/* Key Contacts */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          padding: '16px',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
        }}>
          <h4 style={{ fontWeight: '600', marginBottom: '16px' }}>Key Contacts</h4>
          <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '16px' }}>
            {lead.topContacts.description}
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {lead.topContacts.contactList.map((contact, index) => (
              <div key={index} style={{
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                padding: '12px',
                backgroundColor: '#f9fafb'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                  <div>
                    <h5 style={{ fontWeight: '500', color: '#1f2937' }}>{contact.name}</h5>
                    <p style={{ fontSize: '14px', color: '#6b7280' }}>{contact.role}</p>
                  </div>
                  <div style={{ textAlign: 'right', fontSize: '14px', color: '#6b7280' }}>
                    {contact.linkedinProfileUrl && contact.linkedinProfileUrl.trim() && (
                      <div style={{ marginBottom: '8px' }}>
                        <LinkedInButton
                          profileUrl={contact.linkedinProfileUrl}
                          size="sm"
                        />
                      </div>
                    )}
                    <div>{contact.bestGuessEmail || 'N/A'}</div>
                    <div>{contact.bestGuessPhone || 'N/A'}</div>
                  </div>
                </div>
                <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px' }}>
                  {contact.reason}
                </p>
                <div style={{
                  backgroundColor: '#dbeafe',
                  borderRadius: '4px',
                  padding: '8px'
                }}>
                  <p style={{ fontSize: '14px', color: '#1d4ed8', fontWeight: '500', margin: '0 0 4px 0' }}>
                    Conversation Starter:
                  </p>
                  <p style={{ fontSize: '14px', color: '#1e40af', margin: 0 }}>
                    {contact.conversationStarter}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadCardContent;